import { registerQuery } from 'data-fetching-client';
import { getInvoiceSettings } from '../api/SettingsAPI';
export const FETCH_INVOICE_SETTINGS = registerQuery({
  fieldName: 'invoiceSettings',
  fetcher: getInvoiceSettings
});